import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let human_user = new BaseTableModule('/ws/human_department/');

const state = {
    ...human_user.state,
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['department'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
    columns: [
        {text: '', value: 'edit', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Department', value: 'department', sortable: true, filterable: true, divider: true, brief: true,},
        ]

};
const getters = {
    ...human_user.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...human_user.actions,
};
const mutations = {
    ...human_user.mutations,
};

export default {
    modules: {
        HRDepartment: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}